// extracted by mini-css-extract-plugin
module.exports = {"not-found-page":"styles_not-found-page__2jNyU"};